import type { FieldMessageVariants } from "./field-message.styles";
import type { IconName } from "./icon.names";

export type FieldMessageIntent = FieldMessageVariants["intent"];

export type FieldMessageIconNameMap = Record<
  NonNullable<FieldMessageIntent>,
  IconName | null
>;

export const fieldMessageIconNameMap = {
  unset: null,
  subtle: null,
  error: "ms-error-filled",
  warning: "ms-warning-filled",
  success: "ms-check",
  info: "ms-info",
  help: "ms-help",
} as const satisfies FieldMessageIconNameMap;

export function toFieldMessageIconName(
  intent?: FieldMessageIntent,
  iconName?: IconName | null,
) {
  if (iconName === null) {
    return null;
  }
  if (iconName) {
    return iconName as IconName;
  }
  if (intent && fieldMessageIconNameMap[intent]) {
    return `${fieldMessageIconNameMap[intent]}` as IconName;
  }
  return null;
}
